<div class="modal-content" ngbAutofocus>
  <div *ngIf="title" class="modal-header">
    <p class="modal-title">{{ title }}</p>
  </div>
  <div class="modal-body">
    <h5 class="text-center">{{ message }}</h5>
    <p class="text-center mt-2" *ngIf="messageL2">{{ messageL2 }}</p>
  </div>
  <div class="modal-footer mx-auto p-0 mb-3 border-0">
    <button *ngIf="cancelButtonTitle" type="button" class="btn btn-danger" id="cancel" (click)="cancel()">
      <i class="feather icon-x-circle me-1"></i>{{ cancelButtonTitle }}
    </button>
    <button *ngIf="confirmButtonTitle" type="button" class="btn btn-success" id="confirm" (click)="confirm()">
      <i class="feather icon-check-circle me-1"></i>{{ confirmButtonTitle }}
    </button>
  </div>
</div>